import $ from 'jquery'

import TopicTeasers from '../utils/topic-teaser/TopicTeasers'
import ThemeLetters from '../utils/topic-teaser/ThemeLetters'

import {
  TRIGGER_SELECTOR,
  CONTENT_SELECTOR,
  ACTIVE_CLASS,
  ALL_LETTERS_BUTTON_CLASS,
} from '../constants/topic-list'

class TopicList {
  constructor(selector = '.topic-list__teaser') {
    this.items = $(selector)

    if (!this.items.length) return

    this.teasersParentEl = document.querySelector('.topic-list__teasers')
    this.lettersParentEl = document.querySelector('.topic-list__letters')

    this.topicTeasers = new TopicTeasers(this.teasersParentEl)
    this.themeLetters = new ThemeLetters(this.lettersParentEl)
    this.allLettersButton = document.querySelector(`.${ALL_LETTERS_BUTTON_CLASS}`)

    this.initFilteringBySearchParams()
    this.initUncollapsedListeners()

    if (!this.topicTeasers.teasers.some(teaser => teaser.isUncollapsed())) {
      this.init()
    }
  }

  init() {
    this.items.each((index, item) => new Accordion(item))
  }

  initUncollapsedListeners() {
    this.themeLetters.themeLetters.map(themeLetter =>
      themeLetter.letterEl.addEventListener('click', this.handleLetterButtonClick.bind(this))
    )
    this.allLettersButton.addEventListener('click', this.handleAllLettersButtonClick.bind(this))
    window.addEventListener('popstate', this.handleStateChange.bind(this))
  }

  initFilteringBySearchParams() {
    const clickedLetter = this.getClickedLetterFromSearchParams()

    this.topicTeasers.toggleEmptyTeasersUI(clickedLetter)
    if (!clickedLetter) return

    this.topicTeasers.filterListUIByLetter(clickedLetter)
    this.themeLetters.findLetterElByLetter(clickedLetter).activate()
  }

  handleStateChange(event) {
    const selectedLetter = event.state.clickedLetter || undefined
    this.themeLetters.deactivateLetterButtons()
    this.topicTeasers.toggleEmptyTeasersUI(selectedLetter)

    if (!selectedLetter) {
      this.topicTeasers.showAll()
    }

    if (selectedLetter) {
      this.topicTeasers.filterListUIByLetter(selectedLetter)
      this.themeLetters.findLetterElByLetter(selectedLetter).activate()
    }
  }

  handleAllLettersButtonClick(e) {
    e.preventDefault()

    this.topicTeasers.toggleEmptyTeasersUI()
    this.themeLetters.deactivateLetterButtons()
    this.topicTeasers.showAll()

    const url = new URL(location.href)
    url.searchParams.delete('clicked letter')

    history.pushState('', '', url)
  }

  handleLetterButtonClick(e) {
    e.preventDefault()

    const clickedLetter = e.target.innerHTML

    this.topicTeasers.toggleEmptyTeasersUI(clickedLetter)
    this.themeLetters.deactivateLetterButtons()
    this.themeLetters.findLetterElByLetter(clickedLetter).activate()

    this.topicTeasers.filterListUIByLetter(clickedLetter)
    this.pushPageToHistory(clickedLetter)
  }

  pushPageToHistory(clickedLetter) {
    const url = new URL(location.href)

    url.searchParams.set('clicked letter', clickedLetter)

    history.pushState({ clickedLetter }, '', url)
  }

  getClickedLetterFromSearchParams() {
    return new URL(location.href).searchParams.get('clicked letter')
  }
}

class Accordion {
  constructor(item) {
    this.item = $(item)
    this.trigger = $(TRIGGER_SELECTOR, item)
    this.content = $(CONTENT_SELECTOR, item)

    this.isActive = false

    if (!this.trigger.data('uncollapsed')) {
      console.log(this.trigger.data('uncollapsed'))
      this.listen()
    }
  }

  listen() {
    this.trigger.on('click', () => {
      event.preventDefault()
      this.isActive ? this.deactivate() : this.activate()
    })
  }

  activate() {
    this.content.slideDown('fast')
    this.item.addClass(ACTIVE_CLASS)
    this.isActive = !this.isActive
  }

  deactivate() {
    this.item.removeClass(ACTIVE_CLASS)
    this.content.slideUp('fast')
    this.isActive = !this.isActive
  }
}

export default TopicList
